//Util
import { showMensagemErroApi } from "@/frontend/utils/mensagens";

//API
import api from "./api";

//### ROTA DE FIND BY PK ###//
export const ROTA_FIND_BY_PK = {
  //JOB: "job/findPk",
  AUTORIZACAO: "/autorizacao/findPk",
  FORNECEDOR: "/fornecedor/findPk",
  SOLICITACAO: "/solicitacao/findPk",
  SOLICITACAO_PAG: "/solicitacao_pag/findPk",
};

//### ROTA DE FIND UNIQUE ###//
export const ROTA_FIND_UNIQUE = {
  CONTA: "/conta/findUnique",
  GRUPO_CONTA: "/conta_grupo/findUnique",
  IMPOSTO: "/imposto/findUnique",
  FORMA_PAGAMENTO: "/forma_pagamento/findUnique",
  TIPO_DOCUMENTO: "/tipo_documento/findUnique",
  INDICE_REAJUSTE: "/indice_reajuste/findUnique",
  GRUPO_PRODUTO: "/produto_grupo/findUnique",
  SOLICITACAO: "/solicitacao/findUnique",
};

export const ROTA_GET_RESULT = {
  SUGESTAO_CODIGO_EMPRESA: "/empresa/getSugestaoCodigo",
  SUGESTAO_CODIGO_FILIAL: "/filial/getSugestaoCodigo",
  SUGESTAO_CODIGO_FORNECEDOR: "/fornecedor/getSugestaoCodigo",

  APROVACAO_PENDENTE_SOLICITACAO:
    "solicitacao_aprovacao/getAprovacaoPendenteSolicitacao",
  ULTIMA_APROVACAO_SOLICITACAO:
    "solicitacao_aprovacao/getUltimaAprovacaoSolicitacao",
};

/* OBS.: ESSAS FUNÇÕES NÃO ENVIAM MENSAGEM DE ERRO SE O CODIGO DO ERRO FOR "401" - SESSÃO EXPIRADA
 *       POIS A SESSÃO EXPIRADA É TRATADA NO ARQUIVO API.JS, NA CONFIGURAÇÃO DO AXIOS,
 *       REDIRECIONANDO PARA UMA PÁGINA DE SESSÃO EXPIRDA
 */

/*
 * Retorna o objeto ref. ao id (PK) consultado.
 */
export async function api_findByPk(rota, id) {
  //, filtros
  let ret = null;

  try {
    const { data } = await api.get(`${rota}/${id}`);

    //PENDENTE: Alterar para passar a usar filtro
    // const { data } = await api.get(
    //   `${rota}/${id}${filtros ? `?${filtros}` : ""}`,
    // );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar");
  }
  return ret;
}

/*
 * Retorna o objeto ref. ao código (Unique) consultado.
 */
export async function api_findUniqueCodigo(rota, codigo) {
  let ret = null;

  try {
    const { data } = await api.get(`${rota}?codigo=${codigo}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar código");
  }
  return ret;
}

/*
 * Retorna o objeto ref. ao número (Unique) consultado.
 */
export async function api_findUniqueNumero(rota, numero) {
  let ret = null;

  try {
    const { data } = await api.get(`${rota}?numero=${numero}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar número");
  }
  return ret;
}

/*
 * Retorna o objeto ref. a sigla (Unique) consultado.
 */
export async function api_findUniqueSigla(rota, sigla) {
  let ret = null;

  try {
    const { data } = await api.get(`${rota}?sigla=${sigla}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar sigla");
  }
  return ret;
}

/*
 * Retorna o objeto/valor exectuado pela rota.
 */
export async function api_getResultRota(rota, filtros) {
  let ret = null;

  try {
    const { data } = await api.get(`${rota}?${filtros || ""}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar");
  }
  return ret;
}

//### ROTA DE FIND ONE ###//

/*
 * Retorna o objeto Perfil de acordo com o (código ou nome) do perfil e tenant (UNIQUE)
 */
export async function api_findUniquePerfil(nome) {
  let ret = null;

  try {
    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(`perfil/findUnique?nome=${nome}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar perfil");
  }
  return ret;
}

/*
 * Retorna o objeto Job de acordo o id do tipo do job e tenant (UNIQUE)
 */
// export async function api_findUniqueJob(idTipoJob, idTenant) {
//   let ret = null;
//
//   try {
//     //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
//     //porém quando o job é executado pela ferramenta SYSTEM, precisa dizer de qual tenant está executando.
//     let filtro = "";
//     if (idTenant) {
//       filtro = `&id_tenant=${idTenant}`;
//     }
//     const { data } = await api.get(
//       `job/findUniqueJob?id_job_tipo=${idTipoJob}${filtro}`
//     );
//
//     if (data) {
//       ret = data;
//     }
//   } catch (error) {
//     showMensagemErroApi(error, "consultar job");
//   }
//   return ret;
// }

/*
 * Retorna o objeto ParametrizacaoTenant de acordo com o id tenant e id parametrização (UNIQUE)
 */
export async function api_findUniqueParametrizacaoTenant(idParametrizacao) {
  let ret = null;

  try {
    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(
      `parametrizacao_tenant/findUnique?id_parametrizacao=${idParametrizacao}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar parametrização");
  }
  return ret;
}

/*
 * Retorna o objeto Empresa de acordo com o (código ou CNPJ) da empresa e tenant (UNIQUE)
 */
export async function api_findUniqueEmpresa(tipo = "CODIGO", valor) {
  let ret = null;

  try {
    let filtroUnique = "";
    if (tipo == "CODIGO") {
      filtroUnique = `codigo=${valor}`;
    } else if (tipo == "CNPJ") {
      filtroUnique = `cnpj=${valor}`;
    }

    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(`empresa/findUnique?${filtroUnique}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar empresa");
  }
  return ret;
}

/*
 * Retorna o objeto Filial de acordo com o (código ou CNPJ) da filial e tenant (UNIQUE)
 */
export async function api_findUniqueFilial(tipo = "CODIGO", valor) {
  let ret = null;

  try {
    let filtroUnique = "";
    if (tipo == "CODIGO") {
      filtroUnique = `codigo=${valor}`;
    } else if (tipo == "CNPJ") {
      filtroUnique = `cnpj=${valor}`;
    }

    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(`filial/findUnique?${filtroUnique}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar filial");
  }
  return ret;
}

/*
 * Retorna o objeto Fornecedor de acordo com o (código ou CNPJ/CPF) do fornecedor e tenant (UNIQUE)
 */
export async function api_findUniqueFornecedor(tipo = "CODIGO", valor) {
  let ret = null;

  try {
    let filtroUnique = "";
    if (tipo == "CODIGO") {
      filtroUnique = `codigo=${valor}`;
    } else if (tipo == "CNPJ" || tipo == "CPF" || tipo == "CNPJ_CPF") {
      filtroUnique = `cnpj_cpf=${valor}`;
    }

    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(`fornecedor/findUnique?${filtroUnique}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar fornecedor");
  }
  return ret;
}

/*
 * Retorna o objeto CentroCusto de acordo com o código e tenant (UNIQUE)
 */
export async function api_findUniqueCentroCusto(codigo) {
  let ret = null;

  try {
    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(`centro_custo/findUnique?codigo=${codigo}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar centro de custo");
  }
  return ret;
}

/*
 * Verifica se o número do contrato já existe no tenant em outra solicitação
 */
export async function api_findNumeroContrato(
  idSolicitacao,
  idFornecedor,
  numero,
) {
  let ret = null;

  try {
    let filtros = `numero=${numero}`;

    if (idSolicitacao) {
      filtros += `&id_solicitacao=${idSolicitacao}`;
    }

    if (idFornecedor) {
      filtros += `&id_fornecedor=${idFornecedor}`;
    }

    //Obs.: O id_tenant já é passado automaticamente na query de toda requisição
    const { data } = await api.get(
      `solicitacao_contrato/findNumeroContrato?${filtros}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar número contrato");
  }
  return ret;
}

/*
 * Retorna o objeto Alcada de acordo com o id do perfil (UNIQUE)
 */
export async function api_findUniqueAlcada(idPerfil) {
  let ret = null;

  try {
    const { data } = await api.get(`alcada/findUnique?id_perfil=${idPerfil}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar alçada");
  }
  return ret;
}

/*
 * Retorna o objeto IndiceReajuste de acordo com a sigla (UNIQUE)
 */
export async function api_findUniqueIndiceReajuste(sigla) {
  let ret = null;

  try {
    const { data } = await api.get(`indice_reajuste/findUnique?sigla=${sigla}`);

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar índice reajuste");
  }
  return ret;
}

/*
 * Retorna o objeto IndiceReajuste de acordo com o tenant, id índice e mês/ano (UNIQUE)
 */
export async function api_findUniqueIndiceReajustePerc(idIndice, mesAno) {
  let ret = null;

  try {
    const { data } = await api.get(
      `indice_reajuste_perc/findUnique?id_indice_reajuste=${idIndice}&mes_ano=${mesAno}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(
      error,
      "consultar o percentual mês/ano do índice reajuste",
    );
  }
  return ret;
}

/*
 * Retorna o objeto SolicitacaoReajuste de acordo com o id solicitação e numero reajuste (UNIQUE)
 */
export async function api_findUniqueSolicitacaoReajuste(
  idSolicitacao,
  numeroReajuste,
) {
  let ret = null;

  try {
    const { data } = await api.get(
      `solicitacao_reajuste/findUnique?id_solicitacao=${idSolicitacao}&numero_reajuste=${numeroReajuste}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar reajuste da solicitação");
  }
  return ret;
}

/*
 * Retorna o objeto SolicitacaoPag de acordo com o id solicitação e numero pagamento (UNIQUE)
 */
export async function api_findUniqueSolicitacaoPag(idSolicitacao, numPag) {
  let ret = null;

  try {
    const { data } = await api.get(
      `solicitacao_pag/findUnique?id_solicitacao=${idSolicitacao}&num_pag=${numPag}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "consultar pagamento da solicitação");
  }
  return ret;
}

// /*
//  * Retorna o objeto NotaEntradaImp de acordo com o tenant e a data entrada (UNIQUE)
//  */
// export async function api_findUniqueImportacaoNotaEntrada(dataEntrada) {
//   let ret = null;

//   try {
//     const { data } = await api.get(
//       `nota_entrada_imp/findUnique?data_entrada=${dataEntrada}`,
//     );

//     if (data) {
//       ret = data;
//     }
//   } catch (error) {
//     showMensagemErroApi(error, "consultar importação nota entrada");
//   }
//   return ret;
// }
